__turbopack_context__.v({
  "className": "manrope_7102bd49-module__TIbn1W__className",
  "variable": "manrope_7102bd49-module__TIbn1W__variable",
});
